const path = {
  root: '/',
  login: '/login',
  authCallback: '/callback',
  cabinetMaster: '/cabinet_master',
  companyContractTagList: '/company_contract_tag_list',
  clientList: '/client_list',
  originalLabelList: '/original_label_list',
  helpCenter: '/help_center',
  pageNotFound: '/*'
};

module.exports = path;
